export default "__VITE_ASSET__IfT7nDlR__"